@if (isOpen) {
  <dialog class="daisy-modal daisy-modal-open z-50">
    <div
      class="daisy-modal-box max-w-lg p-6 bg-base-100 shadow-2xl border border-base-200"
    >
      <!-- Modal Header -->
      <div
        class="flex items-center justify-between pb-3 border-b border-base-200"
      >
        <div class="flex items-center gap-3">
          <div
            class="w-10 h-10 rounded-xl bg-primary/10 text-primary flex items-center justify-center"
          >
            <i class="fa-solid fa-user-plus text-lg"></i>
          </div>
          <div>
            <h3 class="font-bold text-lg text-base-content">
              {{
                modalTitle ||
                  (allowRoleSelection ? 'Invite Users' : 'Invite Students')
              }}
            </h3>
            <p class="text-xs text-base-content/60">
              Send email or SMS invitations to join your academy
            </p>
          </div>
        </div>
        <button
          type="button"
          class="daisy-btn daisy-btn-sm daisy-btn-ghost daisy-btn-square"
          (click)="onClose()"
          aria-label="Close modal"
        >
          <i class="fa-solid fa-xmark text-lg"></i>
        </button>
      </div>

      <!-- Role Switcher (If role selection is allowed) -->
      @if (allowRoleSelection) {
        <div class="mt-4">
          <label
            class="block text-xs font-semibold uppercase tracking-wider text-base-content/70 mb-2"
          >
            Target Role
          </label>
          <div class="grid grid-cols-3 gap-2 bg-base-200 p-1 rounded-xl">
            <button
              type="button"
              class="daisy-btn daisy-btn-sm border-0 flex items-center justify-center gap-1.5 text-xs transition-all"
              [ngClass]="
                selectedRole === 'STUDENT'
                  ? 'daisy-btn-primary shadow-sm'
                  : 'daisy-btn-ghost hover:bg-base-300/50'
              "
              (click)="setRole('STUDENT')"
            >
              <i class="fa-solid fa-user-graduate"></i>
              <span>Student</span>
            </button>
            <button
              type="button"
              class="daisy-btn daisy-btn-sm border-0 flex items-center justify-center gap-1.5 text-xs transition-all"
              [ngClass]="
                selectedRole === 'INSTRUCTOR'
                  ? 'daisy-btn-primary shadow-sm'
                  : 'daisy-btn-ghost hover:bg-base-300/50'
              "
              (click)="setRole('INSTRUCTOR')"
            >
              <i class="fa-solid fa-chalkboard-user"></i>
              <span>Instructor</span>
            </button>
            <button
              type="button"
              class="daisy-btn daisy-btn-sm border-0 flex items-center justify-center gap-1.5 text-xs transition-all"
              [ngClass]="
                selectedRole === 'ADMINISTRATOR'
                  ? 'daisy-btn-primary shadow-sm'
                  : 'daisy-btn-ghost hover:bg-base-300/50'
              "
              (click)="setRole('ADMINISTRATOR')"
            >
              <i class="fa-solid fa-user-shield"></i>
              <span>Admin</span>
            </button>
          </div>
        </div>
      }

      <!-- Invite Channel Switcher (Email vs SMS) -->
      <div class="mt-4">
        <label
          class="block text-xs font-semibold uppercase tracking-wider text-base-content/70 mb-2"
        >
          Invitation Method
        </label>
        <div class="grid grid-cols-2 gap-2 bg-base-200 p-1 rounded-xl">
          <button
            type="button"
            class="daisy-btn daisy-btn-sm border-0 flex items-center justify-center gap-2 transition-all"
            [ngClass]="
              mode === 'EMAIL'
                ? 'daisy-btn-primary shadow-sm'
                : 'daisy-btn-ghost hover:bg-base-300/50'
            "
            (click)="setMode('EMAIL')"
          >
            <i class="fa-solid fa-envelope"></i>
            <span>Email</span>
          </button>
          <button
            type="button"
            class="daisy-btn daisy-btn-sm border-0 flex items-center justify-center gap-2 transition-all"
            [ngClass]="
              mode === 'MOBILE'
                ? 'daisy-btn-primary shadow-sm'
                : 'daisy-btn-ghost hover:bg-base-300/50'
            "
            (click)="setMode('MOBILE')"
          >
            <i class="fa-solid fa-mobile-screen"></i>
            <span>Mobile SMS</span>
          </button>
        </div>
      </div>

      <!-- Mode Options (Single vs Bulk) -->
      <div class="flex items-center justify-between mt-4">
        <label
          class="text-xs font-semibold uppercase tracking-wider text-base-content/70"
        >
          {{ mode === 'EMAIL' ? 'Recipient Email' : 'Recipient Mobile Number' }}
        </label>
        <button
          type="button"
          class="text-xs text-primary hover:underline flex items-center gap-1 font-medium"
          (click)="toggleBulk()"
        >
          <i class="fa-solid" [ngClass]="isBulk ? 'fa-user' : 'fa-users'"></i>
          {{ isBulk ? 'Switch to Single Recipient' : 'Invite Multiple (Bulk)' }}
        </button>
      </div>

      <!-- Recipient Input -->
      <div class="mt-2 space-y-3">
        @if (!isBulk) {
          <div>
            <div class="relative">
              <span
                class="absolute inset-y-0 left-0 flex items-center pl-3 text-base-content/40"
              >
                <i
                  class="fa-solid"
                  [ngClass]="mode === 'EMAIL' ? 'fa-at' : 'fa-phone'"
                ></i>
              </span>
              <input
                [type]="mode === 'EMAIL' ? 'email' : 'tel'"
                class="daisy-input daisy-input-bordered w-full pl-9"
                [placeholder]="
                  mode === 'EMAIL' ? 'user@example.com' : '+94 77 123 4567'
                "
                [(ngModel)]="singleRecipient"
                [disabled]="isSending()"
              />
            </div>
          </div>

          <div>
            <label
              class="block text-xs font-semibold text-base-content/70 mb-1"
            >
              Full Name
              <span class="font-normal text-base-content/50">(Optional)</span>
            </label>
            <input
              type="text"
              class="daisy-input daisy-input-bordered w-full"
              placeholder="e.g. Kasun Perera"
              [(ngModel)]="studentName"
              [disabled]="isSending()"
            />
          </div>
        } @else {
          <div>
            <textarea
              class="daisy-textarea daisy-textarea-bordered w-full h-24 text-sm font-mono"
              [placeholder]="
                mode === 'EMAIL'
                  ? 'Enter emails separated by commas or new lines:\nuser1@example.com\nuser2@example.com'
                  : 'Enter mobile numbers separated by commas or new lines:\n+94771234567\n+94712345678'
              "
              [(ngModel)]="bulkRecipients"
              [disabled]="isSending()"
            ></textarea>
            <p class="text-xs text-base-content/50 mt-1">
              Separate each
              {{ mode === 'EMAIL' ? 'email' : 'phone number' }} with a comma or
              new line.
            </p>
          </div>
        }

        <!-- Learning Item Attachment (Optional, for Students) -->
        @if (
          selectedRole === 'STUDENT' &&
          (availableLiveClasses.length > 0 || availableCourses.length > 0)
        ) {
          <div>
            <label
              class="block text-xs font-semibold uppercase tracking-wider text-base-content/70 mb-2"
            >
              Assign Learning Item
              <span class="font-normal text-base-content/50 normal-case"
                >(Optional)</span
              >
            </label>

            @if (
              availableLiveClasses.length > 0 && availableCourses.length > 0
            ) {
              <div
                class="grid grid-cols-3 gap-2 bg-base-200 p-1 rounded-xl mb-3"
              >
                <button
                  type="button"
                  class="daisy-btn daisy-btn-xs border-0 flex items-center justify-center gap-1.5 transition-all"
                  [ngClass]="
                    targetType === 'NONE'
                      ? 'daisy-btn-primary shadow-sm'
                      : 'daisy-btn-ghost hover:bg-base-300/50'
                  "
                  (click)="targetType = 'NONE'"
                >
                  <i class="fa-solid fa-school"></i>
                  <span>General</span>
                </button>
                <button
                  type="button"
                  class="daisy-btn daisy-btn-xs border-0 flex items-center justify-center gap-1.5 transition-all"
                  [ngClass]="
                    targetType === 'LIVE_CLASS'
                      ? 'daisy-btn-primary shadow-sm'
                      : 'daisy-btn-ghost hover:bg-base-300/50'
                  "
                  (click)="targetType = 'LIVE_CLASS'"
                >
                  <i class="fa-solid fa-video"></i>
                  <span>Live Class</span>
                </button>
                <button
                  type="button"
                  class="daisy-btn daisy-btn-xs border-0 flex items-center justify-center gap-1.5 transition-all"
                  [ngClass]="
                    targetType === 'COURSE'
                      ? 'daisy-btn-primary shadow-sm'
                      : 'daisy-btn-ghost hover:bg-base-300/50'
                  "
                  (click)="targetType = 'COURSE'"
                >
                  <i class="fa-solid fa-graduation-cap"></i>
                  <span>Course</span>
                </button>
              </div>
            }

            @if (
              targetType === 'LIVE_CLASS' ||
              (availableCourses.length === 0 && availableLiveClasses.length > 0)
            ) {
              <select
                class="daisy-select daisy-select-bordered w-full"
                [(ngModel)]="selectedLiveClassId"
                [disabled]="isSending()"
              >
                <option value="">
                  General Academy Invitation (No specific class)
                </option>
                @for (lc of availableLiveClasses; track lc.id) {
                  <option [value]="lc.id">
                    {{ lc.title }}
                    {{ lc.settings.isPublic === false ? '(Unlisted)' : '' }}
                  </option>
                }
              </select>
            } @else if (
              targetType === 'COURSE' ||
              (availableLiveClasses.length === 0 && availableCourses.length > 0)
            ) {
              <select
                class="daisy-select daisy-select-bordered w-full"
                [(ngModel)]="selectedCourseId"
                [disabled]="isSending()"
              >
                <option value="">
                  General Academy Invitation (No specific course)
                </option>
                @for (c of availableCourses; track c._id) {
                  <option [value]="c._id">
                    {{ c.title }}
                    {{ c.settings.isPublic === false ? '(Unlisted)' : '' }}
                  </option>
                }
              </select>
            } @else {
              <p class="text-xs text-base-content/50 italic px-1">
                Student will receive general academy access without automated
                enrollment.
              </p>
            }
          </div>
        }

        <!-- Custom Personal Message -->
        <div>
          <label class="block text-xs font-semibold text-base-content/70 mb-1">
            Personal Note
            <span class="font-normal text-base-content/50">(Optional)</span>
          </label>
          <input
            type="text"
            class="daisy-input daisy-input-bordered w-full text-sm"
            placeholder="e.g. Welcome to our academy! Excited to have you on the team."
            [(ngModel)]="customMessage"
            maxlength="200"
            [disabled]="isSending()"
          />
        </div>
      </div>

      <!-- Action Buttons -->
      <div class="daisy-modal-action mt-6 pt-4 border-t border-base-200">
        <button
          type="button"
          class="daisy-btn daisy-btn-ghost"
          (click)="onClose()"
          [disabled]="isSending()"
        >
          Cancel
        </button>
        <button
          type="button"
          class="daisy-btn daisy-btn-primary gap-2"
          (click)="sendInvitation()"
          [disabled]="isSending() || (!singleRecipient && !bulkRecipients)"
        >
          @if (isSending()) {
            <span
              class="daisy-loading daisy-loading-spinner daisy-loading-sm"
            ></span>
            <span>Sending...</span>
          } @else {
            <i class="fa-solid fa-paper-plane"></i>
            <span>Send Invitation</span>
          }
        </button>
      </div>
    </div>
    <div class="daisy-modal-backdrop bg-black/50" (click)="onClose()"></div>
  </dialog>
}
